import React from 'react'

const Appraise = () => {
  return (
    <div>Appraise</div>
  )
}

export default Appraise